import { render, staticRenderFns } from "./UserHeader.vue?vue&type=template&id=4c20adf2&scoped=true&"
import script from "./UserHeader.vue?vue&type=script&lang=ts&"
export * from "./UserHeader.vue?vue&type=script&lang=ts&"
import style0 from "./UserHeader.vue?vue&type=style&index=0&id=4c20adf2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c20adf2",
  null
  
)

export default component.exports